import React from 'react';
import API from './api/api'
import cookie from 'react-cookies'
import { Layout }   from 'antd';
import axios from 'axios'
import Config from './config/pages'
//import localStorage from 'localStorage';

// 允许跨域
axios.defaults.withCredentials = true;

function Signout() {
    //const [route,setRoute] = React.useState("/index")
    React.useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        //save redirect url
        const token = queryParams.get("token")
        //remove token in localstorage
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("email")

        const token_name = cookie.load('token_name') || 'token'
        cookie.remove('token_name')
        cookie.remove(token_name,{domain: '.english1.cn',path: '/',secure: true})
        //cookie.remove('email')
        //set signout 3rd flag,for signin page use
        //window.localStorage.setItem("signout3rd","1")

        Config.SIGNOUT_3RD_URL.map(url=>{
            axios.get(url)
            .then(res=>{
              console.log(res)
            })
            .catch(function (error) {
        
            })
          })
        window.location.href=API.logout+"?token="+token


    },[])
    return(
        <Layout className='h-screen'>
        </Layout>
    )
}
export default Signout;